export function userDisplayName(email: unknown): string {
  if (typeof email !== "string") return "Loading";
  const normalized = email.trim();
  if (!normalized) return "Loading";
  const localPart = normalized.split("@", 1)[0];
  return localPart || "Loading";
}
